"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VestingClaimUploadButton = exports.VESTING_CLAIM_UPLOAD_DIALOG_KEY = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const icons_material_1 = require("@mui/icons-material");
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const styled_1 = require("@framework/styled");
const provider_api_firebase_1 = require("@dzambalaorg/provider-api-firebase");
const dialog_1 = require("./dialog");
exports.VESTING_CLAIM_UPLOAD_DIALOG_KEY = "vestingClaimUpload";
const VestingClaimUploadButton = (props) => {
    const { className, disabled, onRefreshPage, variant = styled_1.ListActionVariant.button } = props;
    const { openFormDialog, formDialogUniqueKey, mode } = (0, react_hooks_1.useDialogForm)();
    const api = (0, provider_api_firebase_1.useApi)();
    const handleUploadConfirm = async ({ data }) => {
        await api
            .fetchJson({
            url: "/vesting/claims/upload",
            method: "POST",
            data,
        })
            .then(async () => {
            await onRefreshPage();
        });
    };
    const handleUpload = () => {
        openFormDialog(exports.VESTING_CLAIM_UPLOAD_DIALOG_KEY, void 0, "button");
    };
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleUpload, icon: icons_material_1.Add, message: "form.buttons.upload", className: className, dataTestId: "VestingClaimUploadButton", disabled: disabled, variant: variant }), (0, jsx_runtime_1.jsx)(dialog_1.VestingClaimUploadDialog, { onExternalConfirm: handleUploadConfirm, open: formDialogUniqueKey === `${exports.VESTING_CLAIM_UPLOAD_DIALOG_KEY}.${mode}`, initialValues: {
                    claims: [],
                } })] }));
};
exports.VestingClaimUploadButton = VestingClaimUploadButton;
//# sourceMappingURL=index.js.map